import React from 'react';
import { CustomReportsTool } from './custom-report-tool';

export const CustomReports = props => {
  return <CustomReportsTool isBuilder={false} isBulk={false} {...props} />;
};
